import { isMobile } from '@helpers/basic-funcs';
import React from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import close from '@icons/close.svg'
import call from "@icons/call.svg"
import email from "@icons/email.svg"
import { BottomSheetHeader } from '../BottomForm/index.styled';
import { Contact, SBottomContactUs } from './index.styled';
import { IContact} from './types';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@redux/store';
import { setModalOpen } from '@features/appActionSlice';
import Modal from '@components/atoms/Modal';
import ContactLink from '@components/atoms/ContactLink';

const ContactUs = () => {
    const {modalOpen} = useSelector((state:RootState)=> state.app.value)
    const dispatch = useDispatch<AppDispatch>()
    return (<>
        {
            modalOpen &&
            (<Contact>

                {
                    isMobile()
                    ?<BottomSheetContactUs modalOpen={modalOpen} setModalOpen={(payload:boolean) => dispatch(setModalOpen(payload))} />
                    :<Modal modalOpen={modalOpen} header={`We're here for you`} setModalOpen={(payload:boolean) => dispatch(setModalOpen(payload))} >
                        <ContactLink title={"Call us at"} imgSrc={call} link={"tel:020-7117-3585"} value={"020-7117-3585"} />
                        <ContactLink title={"Drop us a mail"} imgSrc={email} link={"mailto:info@loophealth.com"} value={"info@loophealth.com"} />
                    </Modal>
                }
              </Contact>)
            }
        </>
    );
};

const BottomSheetContactUs:React.FC<IContact> = ({modalOpen, setModalOpen}) => {
    return (
        <SBottomContactUs>
            <BottomSheet
                open={modalOpen ? modalOpen :false}
                defaultSnap={({ maxHeight }) => maxHeight / 2}
                onDismiss={() => setModalOpen(false)}
                header={
                    <BottomSheetHeader>
                        <h3 className="form-header">We’re here for you!</h3>
                        <div onClick={() => setModalOpen(false)} className="close-container">
                            <img src={close} alt="close" />
                        </div>
                    </BottomSheetHeader>
                }
            >
                <div className="contact-us-container" style={{padding:"1.5rem", paddingBottom:"3.4rem"}}>
                    <ContactLink title={"Call us at"} imgSrc={call} link={"tel:020-7117-3585"} value={"020-7117-3585"} />
                    <br />
                    <ContactLink title={"Drop us a mail"} imgSrc={email} link={"mailto:info@loophealth.com"} value={"info@loophealth.com"} />
                </div>
            </BottomSheet>
        </SBottomContactUs>
    )
}

export default ContactUs;
